export default __webpack_public_path__ + "images/a04b90741abf65714100f98b383760c6-home.png";